import { defineMessages } from 'react-intl';

export const actionMessages = defineMessages({
  printFormClicked: {
    id: 'action.printFormClicked',
    defaultMessage: 'View Portfolio',
    description: 'Details Page Viewed.'
  },
  contactMeClicked: {
    id: 'action.contactMeClicked',
    defaultMessage: 'Contact',
    description: 'Contact Form Opened'
  },
  'contactMeClicked.completed': {
    id: 'action.contactMeClicked.completed',
    defaultMessage: 'Completed',
    description: 'Completed contact form'
  },
  contactBankerClicked: {
    id: 'action.contactBankerClicked',
    defaultMessage: 'Contact Banker Clicked',
    description: 'Contact banker button clicked'
  },
  completed: {
    id: 'action.completed',
    defaultMessage: 'Clicked',
    description: 'Clicked'
  },
  started: {
    id: 'action.started',
    defaultMessage: 'Started',
    description: 'Started'
  },
  detailsPrinterClicked: {
    id: 'action.detailsPrinterClicked',
    defaultMessage: 'Print Button',
    description: 'Print Button'
  },
  productDetailsClicked: {
    id: 'action.productDetailsClicked',
    defaultMessage: 'Product Information',
    description: 'Product Information'
  },
  'productDetailsClicked.learnMore': {
    id: 'action.productDetailsClicked.learnMore',
    defaultMessage: 'Learn More',
    description: 'Learn More'
  },
  'productDetailsClicked.productName': {
    id: 'action.productDetailsClicked.productName',
    defaultMessage: 'Product Name',
    description: 'Product Name'
  },
  'productDetailsClicked.quickGuide': {
    id: 'action.productDetailsClicked.quickGuide',
    defaultMessage: 'Quick Guide',
    description: 'Quick Guide'
  },
  shareViaEmailClicked: {
    id: 'action.shareViaEmailClicked',
    defaultMessage: 'Email',
    description: 'Email Form Opened'
  },
  'shareViaEmailClicked.completed': {
    id: 'action.shareViaEmailClicked.completed',
    defaultMessage: 'Sent',
    description: 'Completed email form'
  },
  shareViaSmsClicked: {
    id: 'action.shareViaSmsClicked',
    defaultMessage: 'Text Message',
    description: 'Text Message Form Opened'
  },
  'shareViaSmsClicked.completed': {
    id: 'action.shareViaSmsClicked.completed',
    defaultMessage: 'Sent',
    description: 'Completed text message form'
  },
  applyNowClicked: {
    id: 'action.applyNowClicked',
    defaultMessage: 'Apply',
    description: 'Apply'
  },
  productApplyClicked: {
    id: 'action.productApplyClicked',
    defaultMessage: 'Apply',
    description: 'Apply'
  },
  makeAppointmentClicked: {
    id: 'action.makeAppointmentClicked',
    defaultMessage: 'Make Appointment',
    description: 'Make Appointment'
  },
  appointmentClicked: {
    id: 'action.appointmentClicked',
    defaultMessage: 'Make Appointment',
    description: 'Make Appointment'
  },
  locateBranchClicked: {
    id: 'action.locateBranchClicked',
    defaultMessage: 'Branch Locator',
    description: 'Branch Locator'
  },
  locateMortgageOfficerClicked: {
    id: 'action.locateMortgageOfficerClicked',
    defaultMessage: 'Locate Mortgage Officer',
    description: 'Locate Mortgage Officer'
  },
  viewRatesClicked: {
    id: 'action.viewRatesClicked',
    defaultMessage: 'View Rates',
    description: 'View Rates'
  },
  opened: {
    id: 'action.opened',
    defaultMessage: 'Opened',
    description: 'Opened'
  },
  recommended: {
    id: 'action.recommended',
    defaultMessage: 'Recommended',
    description: 'Recommended'
  }
});

export const keyText = {
  'answerDetailsClicked.completed': 'View Details',
  'languageChangeClicked.completed': 'Change Language',
  'total': 'Guides Started',
  'completed': 'Guides Completed',
  'totalClicked.completed': 'Took Action',
  'totalClicked.completedPercentage': 'Took Action %',
  'otherClicked.completed': 'Other Actions',
  'otherClicked.completedPercentage': 'Other Actions %',
  'printRecsClicked.completed': 'Print Records',
  'contactMeClicked.completed': 'Contact Sent',
  'contactMeClicked.completedPercentage': 'Contact Sent %',
  'contactMeClicked.started': 'Contact Started',
  'contactMeClicked.startedPercentage': 'Contact Started %',
  'contactBankerClicked.completed': 'Contact Banker Clicked',
  'contactBankerClicked.completedPercentage': 'Contact Banker Clicked %',
  'phoneNumberClicked.completed': 'Phone Number',
  'phoneNumberClicked.completedPercentage': 'Phone Number %',
  'detailsPrinterClicked.completed': 'Print Button',
  'printButtonClicked.completed': 'Print Button',
  'detailsPrinterClicked.completedPercentage': 'Print Button %',
  'printFormClicked.completed': 'View Portfolio',
  'printFormClicked.completedPercentage': 'View Portfolio %',
  'productAppointmentClicked.true': 'Product Appointment Selected',
  'productAppointmentClicked.truePercentage': 'Product Appointment Selected %',
  'productDetailsClicked.completed': 'View Product Information',
  'productDetailsClicked.completedPercentage': 'View Product Information %',
  'productDetailsClicked.learnMore': 'Learn More',
  'productDetailsClicked.learnMorePercentage': 'Learn More %',
  'productDetailsClicked.productName': 'Product Name',
  'productDetailsClicked.productNamePercentage': 'Product Name %',
  'productDetailsClicked.quickGuide': 'Quick Guide',
  'productDetailsClicked.quickGuidePercentage': 'Quick Guide %',
  'shareViaEmailClicked.completed': 'Email Sent',
  'shareViaEmailClicked.completedPercentage': 'Email Sent %',
  'shareViaEmailClicked.started': 'Email Started',
  'shareViaEmailClicked.startedPercentage': 'Email Started %',
  'shareViaSmsClicked.completed': 'Text Message Sent',
  'shareViaSmsClicked.completedPercentage': 'Text Message Sent %',
  'shareViaSmsClicked.started': 'Text Message Started',
  'shareViaSmsClicked.startedPercentage': 'Text Message Started %',
  'applyNowClicked.completed': 'Apply',
  'applyNowClicked.completedPercentage': 'Apply %',
  'productApplyClicked.started': 'Apply Started',
  'productApplyClicked.startedPercentage': 'Apply Started %',
  'productApplyClicked.completed': 'Apply',
  'productApplyClicked.completedPercentage': 'Apply %',
  'makeAppointmentClicked.started': 'Make Appointment Started',
  'makeAppointmentClicked.startedPercentage': 'Make Appointment Started %',
  'makeAppointmentClicked.completed': 'Make Appointment Completed',
  'makeAppointmentClicked.completedPercentage': 'Make Appointment Completed %',
  'appointmentClicked.completed': 'Make Appointment',
  'appointmentClicked.completedPercentage': 'Make Appointment %',
  'locateBranchClicked.completed': 'Branch Locator',
  'locateBranchClicked.completedPercentage': 'Branch Locator %',
  'locateMortgageOfficerClicked.completed': 'Locate Mortgage Officer',
  'locateMortgageOfficerClicked.completedPercentage': 'Locate Mortgage Officer %',
  'addToCartClicked.completed': 'Add to Cart',
  'addToCartClicked.completedPercentage': 'Add to Cart %',
  'addToCartClicked.open': 'Add to Cart (Open Today)',
  'addToCartClicked.openPercentage': 'Add to Cart (Open Today) %',
  'addToCartClicked.signUp': 'Add to Cart (Sign Up Today)',
  'addToCartClicked.signUpPercentage': 'Add to Cart (Sign Up Today) %',
  'addToCartClicked.apply': 'Add to Cart (Apply Today)',
  'addToCartClicked.applyPercentage': 'Add to Cart (Apply Today) %',
  'addToCartClicked.enroll': 'Add to Cart (Enroll Today)',
  'addToCartClicked.enrollPercentage': 'Add to Cart (Enroll Today) %',
  'addToCartClicked.register': 'Add to Cart (Register)',
  'addToCartClicked.registerPercentage': 'Add to Cart (Register) %',
  'addLearningToCartClicked.completed': 'Add to Cart (Learn More)',
  'addLearningToCartClicked.completedPercentage': 'Add to Cart (Learn More) %',
  'addLearningToCartClicked.viewCalculator': 'Add Calculator to Cart',
  'addLearningToCartClicked.viewCalculatorPercentage': 'Add Calculator to Cart %',
  'addReferralToCartClicked.completed': 'Add Referral to Cart',
  'addReferralToCartClicked.completedPercentage': 'Add Referral to Cart %',
  'addReferralToCartClicked.discussWithLicensedBanker': 'Add Licensed Banker Referral to Cart',
  'addReferralToCartClicked.discussWithLicensedBankerPercentage': 'Add Licensed Banker Referral to Cart %',
  'addReferralToCartClicked.discussWithFinancialAdvisor': 'Add Financial Advisor Referral to Cart',
  'addReferralToCartClicked.discussWithFinancialAdvisorPercentage': 'Add Financial Advisor Referral to Cart %',
  'addReferralToCartClicked.discussWithWealthAdvisor': 'Add Wealth Advisor Referral to Cart',
  'addReferralToCartClicked.discussWithWealthAdvisorPercentage': 'Add Wealth Advisor Referral to Cart %',
  'addReferralToCartClicked.openWithMlo': 'Add Mortgage Loan Officer Referral to Cart',
  'addReferralToCartClicked.openWithMloPercentage': 'Add Mortgage Loan Officer Referral to Cart %',
  'saveForLaterClicked.completed': 'Save for Later',
  'saveForLaterClicked.completedPercentage': 'Save for Later %',
  'viewRatesClicked.completed': 'View Rates',
  'viewRatesClicked.completedPercentage': 'View Rates %',
  'viewCartButtonClicked.completed': 'View Cart',
  'opened.opened': 'Opened',
  'recommended.recommended': 'Recommended'
};



// WEBPACK FOOTER //
// ./src/intl/ActionMessages.js